import React, { useState, useEffect, useContext, useRef } from 'react';
import {Tabs} from '@shopify/polaris';
import ContactForm from '../../ContactForm'
import PasswordForm from '../../PasswordForm'
import { Util, SearchContext, FormProvider, useReducerTab } from '@thinkwell/react.common'
import { TextField, Spinner, EditModal } from '@thinkwell/react.polaris'
import LogoutButton from '../LogoutButton'
import { HostContext } from '../../contexts/Host'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'

export default function EditTempAccess(props) {
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const [query, setQuery] = useContext(SearchContext)

  const tabs = [
    {
      id: 'existing',
      content: 'Have a Thinkwell account?'
    },
    {
      id: 'new',
      content: "No Thinkwell account?"
    }
  ];

  const [state, onTabSelected] = useReducerTab(props, tabs)

  const setActiveRef = useRef(null);

  useEffect(() => {
    if (Util.getParam(window.location.href, 'temp_access') == props.section.section_id) {
      setActiveRef.current(true)
    }
  }, []);

  const data = {
    customer: {
      section_id: props.section.section_id,
      email: customer && customer.email,
      new_account: false
    },
    existing: {
      section_id: props.section.section_id,
      login: true
    },
    new: {
      section_id: props.section.section_id,
      new_account: true
    }
  }

  let saveText;
  if (customer) {
    saveText = props.section.is_enrolled ? '' : 'Sign Up'
  } else if (state.tabSelected == 'existing') {
    saveText = "Login"
  } else if (state.tabSelected == 'new') {
    saveText = "Create"
  }

  let scope;
  if (customer) {
    scope = "customer"
  } else if (state.tabSelected == 'existing') {
    scope = "existing"
  } else if (state.tabSelected == 'new') {
    scope = "new"
  }

  return (<FormProvider data={data} scope={scope}><EditModal
    setActiveRef={setActiveRef}
    onActive={props.onActive}
    method="post"
    url={`https://${host}/accounts/temp_access?shop_name=${shop_name}`}
    linkText='14-day Temporary Access'
    linkClass="button orange registration-link"
    title="Get 14-day Temporary Access"
    saveText={saveText}
  >
    <div>
      <div>{`${props.section.school} - ${props.section.course} - ${props.section.section}`}</div>
      { customer ?
        (<div>
          <div className="customer-info">{`${customer.first_name} ${customer.last_name}`}<br/>{customer.email}</div>
          <div>&nbsp;</div>
          {props.section.is_enrolled ? <div><div>You have already signed up for this class.</div><div>&nbsp;</div></div> : null}
          <LogoutButton params={{query: query, temp_access: props.section.section_id}}/>
        </div>)
      : (
      <Tabs tabs={tabs} selected={state.tabIndexSelected} onSelect={onTabSelected} fitted>
        { state.tabSelected == 'existing' ? (<div>
          <TextField required
            label="Email / Username"
            name="username"
          />
          <PasswordForm />
        </div>) : null }
        { state.tabSelected == 'new' ? (<div>
          <ContactForm required={['first_name', 'last_name']} />
          <PasswordForm />
        </div>) : null }
      </Tabs>)}
    </div>
  </EditModal></FormProvider>)
}
